/**
 * @file Builds an Imgix URL for an S3 file.
 */

import ImgixClient from "@imgix/js-core";

import { getConfig } from "@components/Config";

import type { ImgixOptions } from "./types";

const IMGIX_HOST = "imgix.net";

const IMGIX_DOMAIN = getConfig<string>("IMGIX_DOMAIN");
const S3_BUCKET_URL = getConfig<string>("S3_BUCKET_URL");

const DEFAULT_OPTIONS: ImgixOptions = {
  auto: "compress",
};

/**
 * Builds the Imgix URL for the given S3 file, or returns it unchanged when it is already an Imgix URL.
 */
const getImgixUrl = (url: string, options: ImgixOptions = {}): string => {
  const isImgixImage = url.includes(IMGIX_HOST);

  if (isImgixImage) {
    return url;
  }

  const client = new ImgixClient({ domain: IMGIX_DOMAIN });
  const path = url.replace(S3_BUCKET_URL, "");
  const imgixUrl = client.buildURL(path, { ...options, ...DEFAULT_OPTIONS });

  return imgixUrl;
};

export default getImgixUrl;
